module.exports = __webpack_public_path__ + "img/opentable.6482d59e.png";